/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import ModalBaseLayout from '../ModalBaseLayout';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionModalHide} from '../../../store/actions/actions-modal';

class ModalLoading extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center modal-loading',
      closeButton: true,
      keyboard: true,
    });
  }

  onCancelClick = () => {
    this.props.ActionModalHide();
  };

  render() {
    const {text} = this.props;

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container">
          <div className="modal-content">
            <div className="modal-loading_spinner-wrap"><div className="modal-loading_spinner" /></div>
            <p className="modal-loading_text">{text}</p>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalLoading.propTypes = {};

function mapStateToProps({}) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalLoading);
